export default __webpack_public_path__ + "static/media/profilepic2.47072209.jpg";